import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import Drip from 'drip';
export default {
  name: 'DailyCoupon',
  components: {},
  props: {
    dailyCouponData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      cardTitle: '',
      cardRightText: ['', '', '']
    };
  },
  computed: {
    performanceId: function performanceId() {
      return this.dailyCouponData.dailyCouponGroupProjects.map(function (item) {
        return item.projectId;
      }).join(',');
    }
  },
  watch: {
    dailyCouponData: "initData"
  },
  mounted: function mounted() {
    this.initData();
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_e4gfkopp_mv',
      custom: {
        performance_id: this.performanceId
      }
    });
  },
  methods: {
    initData: function initData() {
      // 判断是否是周四
      var isThursday = dayjs().day() === 4;
      this.cardTitle = isThursday ? '省钱星期四' : '天天神券';
      this.cardRightText = isThursday ? ['周周', '4', '折起'] : ['抢', '50', '元神券'];
    },
    handleClickCard: function handleClickCard() {
      var performanceId = this.performanceId;
      window.lxTagReport('c_movie_aq5xt2v5', 'b_movie_e4gfkopp_mc', {
        performance_id: performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_e4gfkopp_mc',
        performance_id: performanceId,
        custom: {
          performance_id: performanceId
        }
      });
      var url = this.dailyCouponData.activityUrl;
      Drip.redirect(url);
    }
  }
};